import { useTranslation } from 'react-i18next';

import {
  calculationOnCode,
  calculationOnNumber,
} from 'modules/accommodations/features/reservations/consts';

export const ServiceCalculation = (applyDiscountPriceTo: number): string => {
  const { t } = useTranslation();

  switch (applyDiscountPriceTo) {
    case calculationOnNumber[10]:
      return t(calculationOnCode[10]);
    case calculationOnNumber[20]:
      return t(calculationOnCode[20]);
    default:
      return t(calculationOnCode.else);
  }
};
